export default __webpack_public_path__ + "static/media/graphs.123315ef.svg";